import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import TextFieldMUI from "@mui/material/TextField";

function TextField({
  methods,
  label,
  name,
  required,
  validator,
  type,
  variant,
  defaultValue,
  rows,
  multiline,
  inputProps,
  helperText,
}) {
  const {
    control,
    formState: { errors },
  } = methods;
  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={{ required, validate: validator }}
        defaultValue={defaultValue}
        render={({ field }) => (
          <TextFieldMUI
            {...field}
            helperText={
              errors?.hasOwnProperty(name) && errors[name].message
                ? errors[name].message
                : helperText ?? " "
            }
            type={type}
            value={field.value || ""}
            error={errors?.hasOwnProperty(name)}
            label={label}
            required={!!required}
            fullWidth
            variant={variant}
            rows={rows}
            multiline={multiline}
            inputProps={inputProps}
          />
        )}
      />
    </React.Fragment>
  );
}

TextField.defaultProps = {
  label: "Ma valeur",
  name: "valeur",
  required: "Merci de saisir votre valeur",
  type: "text",
  validator: null,
  variant: "outlined",
  defaultValue: "",
  rows: 3,
  multiline: false,
};

TextField.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Label du champ
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Message d'erreur si le champ est requis
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * Type de champ HTML input
   */
  type: PropTypes.string,
  /**
   * Fonction de validation
   * validator : (fieldValue) => fieldValue === 'ok' ? undefined : "message d'erreur"
   */
  validator: PropTypes.func,
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
  /**
   * Valeur par défaut du champ
   */
  defaultValue: PropTypes.string,
  /**
   * Nombre de lignes du textArea
   */
  rows: PropTypes.number,
  /**
   * Active le multiline (= textarea)
   */
   multiline: PropTypes.bool,
   /**
    * Props supplémentaires input (type maxLength)
    */
   inputProps: PropTypes.object,
   /**
    * Texte d'aide
    */
   helperText: PropTypes.string,
};

export default TextField;
